if (!customElements.get('home-featured-products')) {
    // 注册自定义元素
    customElements.define("home-featured-products", class HomeFeaturedProducts extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        window.addEventListener('DOMContentLoaded', () => {
          this.observeElement(this, this.handleInViewport.bind(this));
        });
      }
  
      handleInViewport() {
        // 初始化元素
        this.init();
      }
  
      observeElement(element, callback) {
        // 创建一个 IntersectionObserver 实例
        const observer = new IntersectionObserver((entries, observerInstance) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              callback();
              // 只执行一次，停止观察
              observerInstance.unobserve(entry.target);
            }
          });
        }, {
          // 视口外 1/2 高度以内触发
          root: null,
          threshold: 0.5
        });
        // 如果已经在视口内,立即执行回调
        if (this.isElementInViewport(element)) {
          callback();
          return;
        }
        observer.observe(element);
      }
  
      // 判断元素是否在视口内
      isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= -el.offsetHeight / 2 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
        );
      }
  
      init() {
        const productGrid = this.querySelector(".products-grid");
        this.productGrid = productGrid;
        const row = Number(productGrid.getAttribute("data-row"));
        const gridItemWidth = row;
        const hasRightSidebar = this.querySelector(".halo-product-content .pro-page [data-has-right-sidebar]");
        const gridItemMobileWidth = productGrid.getAttribute("data-mobilerow");
        const slidesToShow = hasRightSidebar ? 5 : row;
        const slidesToShow1400 = this.classList.contains("has-banner") ? 3 : gridItemWidth > 5 ? 5 : row;
        let slidesToShow1200 = 2;
        if (!this.classList.contains("has-banner")) {
          if (gridItemWidth >= 4) {
            slidesToShow1200 = 4;
          } else if ((gridItemWidth = 3)) {
            slidesToShow1200 = 3;
          }
        }
        const vertical = productGrid.classList.contains("verticle");
        const slidesToScroll = productGrid.classList.contains("verticle") ? 1 : row;
        let slidesToScroll1400 = 3;
        if (productGrid.classList.contains("verticle")) {
          slidesToScroll1400 = 1;
        } else {
          if (gridItemWidth >= 4) {
            slidesToScroll1400 = 4;
          } else if ((gridItemWidth = 3)) {
            slidesToScroll1400 = 3;
          } else {
            slidesToScroll1400 = 2;
          }
        }
        let slidesToScroll1200 = 3;
        if (!this.classList.contains("has-banner")) {
          if (gridItemWidth >= 4) {
            slidesToScroll1200 = 4;
          } else if ((gridItemWidth = 3)) {
            slidesToScroll1200 = 3;
          }
        }
        this.mySwiper = new Swiper(this.querySelector(`.swiper`), {
          loop: true,
          centeredSlides: false,
          slidesPerView: gridItemMobileWidth,
          slidesPerGroup: gridItemMobileWidth != 2 ? 1 : 2,
          speed: 800,
          observer: true,
          resizeObserver: true,
          navigation: {
            nextEl: this.querySelector(`.swiper-btn-next`),
            prevEl: this.querySelector(`.swiper-btn-prev`),
          },
          pagination: {
            el: this.querySelector(`.swiper-pagination`),
            clickable: true,
          },
          breakpoints: {
            590: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            768: {
              slidesPerView: gridItemWidth >= 3 ? 3 : 2,
              slidesPerGroup: gridItemWidth >= 3 ? 3 : 2,
            },
            992: {
              slidesPerView: slidesToScroll1200,
              slidesPerGroup: slidesToScroll1200,
            },
            1200: {
              slidesPerView: slidesToShow1400,
              slidesPerGroup: slidesToShow1400,
            },
            1400: {
              slidesPerView: slidesToShow,
              slidesPerGroup: slidesToShow,
            },
          },
          on: {
            slideChange: function (swiper) {
              let slides = swiper.slides; // 获取所有 slide
              let activeIndex = swiper.activeIndex; // 当前活动组第一个 slide 的索引
              let groupSize = swiper.params.slidesPerGroup; // 每组包含的 slide 数
              // 清除所有 slide 的自定义类名
              slides.forEach((slide) => {
                slide.setAttribute('aria-hidden', true);
              });
              // 为当前组的 slide 添加自定义类名
              for (let i = activeIndex; i < activeIndex + groupSize; i++) {
                if (slides[i]) {
                  slides[i].removeAttribute('aria-hidden');
                }
              }
            }
          }
        });
      }
    });
  }
  